import { CalendarVisitIntervalResponseDTO } from 'typings/dto/calendarVisitInterval';
import Mapper from './Mapper';
import DateUtils from 'utils/Date';
import DIContainer from 'services/DIContainer';
import DateWithTimezone from 'utils/implementations/DateWithTimezone';

export default class CalendarVisitIntervalMapper extends Mapper<CalendarVisitInterval, CalendarVisitIntervalResponseDTO> {
  constructor(private subEntitiesMappers: DIContainer.SubEntitiesMappers, private dateUtils: DateUtils) {
    super({
      number: 'orderNumber',
      type: 'orderType',
      status: 'orderStatus',
      visitIntervals: 'visitDateIntervals',
      technicianTeam: 'technicianTeam',
      serviceProvider: 'serviceProvider',
      techniciansNumberRequired: 'numberOfTechnicians',
      platformOperator: 'platformOperator',
      technicians: 'technicians',
      region: 'region',
    });
  }

  // внутри ActionsService метод getList переопределен
  public responseDTOToModel(order: CalendarVisitIntervalResponseDTO): any {
    const { technicians, technicianTeam, serviceProvider } = order;
    return order.visitIntervals.flatMap((visitInterval) => {
      let visit = this.subEntitiesMappers.dateInterval.responseDTOToModel(visitInterval, order.region.timezone);
      return {
        ...this.responseDTOToModelViaDiffMap(order),
        visitDateIntervals: order.visitIntervals.map((visitInterval) =>
          this.subEntitiesMappers.dateInterval.responseDTOToModel(visitInterval, order.region.timezone)
        ),
        ...visit,
        id: visit.id,
        technicianTeam,
        technicians,
        serviceProvider,
        orderTimezone: order.region.timezone,
        orderType: order.type,
        orderId: order.id,
        orderNumber: order.number,
        orderStatus: {
          technicalName: order.status.value,
          isProblematic: order.status.problematic,
          isWorkStarted: order.status.onTheJob,
          isWorkInProgress: order.status.workInProgress,
          completionState: order.status.completionState,
          history: {
            updatedAt: new DateWithTimezone(order.status.history.updatedAt, order.region.timezone, this.dateUtils),
            items: order.status.history.items.map((i) => {
              return {
                value: i.value,
                setupAt: new DateWithTimezone(i.setupAt, order.region.timezone, this.dateUtils),
              };
            }),
          },
        },
      };
    });
  }
}